import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AdminService, AuthService, HandleErrorsService } from '../app-services';

export const currentAdminDataResolver: ResolveFn<unknown> = () => {
  const adminService = inject(AdminService);
  const authService = inject(AuthService);
  const handleErrors = inject(HandleErrorsService);
  const credentials = authService.credentials;

  if (!credentials) {
    return throwError(() => new Error('Missing credentials'));
  }

  return adminService.getAdmin(credentials.payload.id).pipe(
    map(res => ({
      ...res.data,
      allowedPPF: Number(res.data.allowedPPF).toFixed(2),
      allowedWindows: Number(res.data.allowedWindows).toFixed(2),
    })),
    catchError(err => {
      handleErrors.handleErrors(err);

      return throwError(() => err);
    }),
  );
};
